import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-social-networks-icons',
    templateUrl: './social-networks-icons.component.html',
    styleUrls: ['./social-networks-icons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SocialNetworksIconsComponent {}
